module.exports = __webpack_public_path__ + "img/second-day-11.107ba77c.webp";